"use client";
import DashboardSprintView from "@/components/dashboard-sprint-view";
import FilterDisplayMode from "@/components/filter-display-mode";
import FilterState from "@/components/filter-state";
import DashboardHeader from "@/components/ui/dashboard-header";
import { getFilterUrlParam } from "@/lib/filters";
import { Suspense } from "react";

export default function SprintPage({
  params: { id },
  searchParams,
}: {
  params: { id: string };
  searchParams?: {
    display?: string[] | "all";
    state?: string[] | "all";
  };
}) {
  const states = getFilterUrlParam(searchParams?.state);
  const display = getFilterUrlParam(searchParams?.display, ["kanban"]);

  return (
    <>
      <div className="text-text">
        <Suspense fallback={<div>Loading...</div>}>
          <DashboardSprintView
            id={id}
            selectedStates={states}
            selectedDisplayModes={display}
          />
        </Suspense>
      </div>
    </>
  );
}
